/**
 * Contrato já está em estado congelado (só descongelar; não congelar de novo).
 */
export function statusIsContractFrozen(status: string | undefined | null): boolean {
  if (status == null || String(status).trim() === '') return false;
  const s = String(status).trim().toLowerCase();
  return s.includes('congel') || s.includes('freez') || s.includes('frozen');
}

/**
 * Regras de negócio: só Vigente, Próximo ao vencimento ou Aguardando pagamento (equivalentes).
 * Não: cancelado, vencido, já congelado, rascunho, aguardando assinatura, etc.
 */
export function statusAllowsContractFreeze(status: string | undefined | null): boolean {
  if (statusIsContractFrozen(status)) return false;
  if (status == null || String(status).trim() === '') return false;
  const s = String(status).trim().toLowerCase();

  const blocked = [
    'cancel',
    'vencid',
    'expired',
    'expirad',
    'draft',
    'rascunh',
    'conclu',
    'encerrad'
  ];
  if (blocked.some((b) => s.includes(b))) return false;

  if (s.includes('aguardando') && s.includes('assin')) return false;
  if (s.includes('pend') && (s.includes('assin') || s.includes('signature'))) return false;
  if (s.includes('inactive') || s.includes('inativo')) return false;

  const vigenteOuAtivo =
    s.includes('vigent') ||
    s === 'active' ||
    (s.includes('ativo') && !s.includes('inativ')) ||
    s.includes('vigente');

  const proximoVencimento =
    ((s.includes('próxim') || s.includes('proxim')) && (s.includes('venc') || s.includes('expir'))) ||
    s.includes('nearexpiration') ||
    s.includes('near_expiration');

  const aguardandoPagamento =
    (s.includes('aguardando') && s.includes('pag') && !s.includes('assin')) ||
    (s.includes('awaiting') && s.includes('payment')) ||
    (s.includes('pending') && s.includes('payment') && !s.includes('assin'));

  return vigenteOuAtivo || proximoVencimento || aguardandoPagamento;
}

/** Contrato está congelado — pode descongelar antes do fim. */
export function statusAllowsContractUnfreeze(status: string | undefined | null): boolean {
  return statusIsContractFrozen(status);
}
